import React from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'

export default class ComboSimpleEntier extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
            alignItems={'center'}>
        <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
          <Select style={this.props.style} inline={this.props.inline} title={this.props.title}
                  disabled={this.props.disabled || false}
                  options={this.props.options} onChange={this.props.onChange}
                  value={this.props.infoTiers === true && this.props.data !== undefined ? this.props.data.id : this.props.data}/>
        </Grid>
        <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
          <Input
            type='number' style={{ width: '100%' }}
            disabled={this.props.disabled || false}
            onChange={this.props.onChangeInput}
            value={this.props.data !== undefined ? this.props.data.valeur_entier : this.props.data}/>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboSimple/ComboSimpleEntier.js